import { useLayoutEffect } from 'react'

import { restoreDemoNaturalLayout } from './scroll-geometry'
import { fitDemoDialogs } from './fit-dialogs'

export const useDemoCalculatorScale = ({ contentRef, modalContainerRef, modalLayerRef }: DemoCalculatorScaleParams) => {
  useLayoutEffect(() => {
    const content = contentRef.current
    const layer = modalLayerRef.current
    const overlay = modalContainerRef.current
    const player = content?.closest<HTMLElement>('.demo-player')
    if (!content || !layer || !overlay || !player) return

    let frame = 0
    const observedCards = new Set<Element>()

    const update = () => {
      frame = 0
      const scale = content.clientWidth / 1168
      if (scale <= 0) return
      const scaleValue = String(scale)
      const overlayHeight = `${layer.clientHeight / scale}px`
      if (player.style.getPropertyValue('--demo-calculator-scale') !== scaleValue) {
        player.style.setProperty('--demo-calculator-scale', scaleValue)
      }
      if (overlay.style.height !== overlayHeight) overlay.style.height = overlayHeight
      const canvas = content.querySelector('.demo-calculator-canvas')
      if (canvas) restoreDemoNaturalLayout(canvas)
      overlay.querySelectorAll('.MuiDialog-paper').forEach(restoreDemoNaturalLayout)
      const cards = new Set(player.querySelectorAll('.demo-dialog'))
      observedCards.forEach(card => {
        if (cards.has(card)) return
        observer.unobserve(card)
        observedCards.delete(card)
      })
      cards.forEach(card => {
        if (observedCards.has(card)) return
        observer.observe(card)
        observedCards.add(card)
      })
      fitDemoDialogs(player)
    }

    // Geometry writes must run outside ResizeObserver delivery.
    const scheduleUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update)
    }

    const observer = new ResizeObserver(scheduleUpdate)
    const mutations = new MutationObserver(scheduleUpdate)
    mutations.observe(player, { childList: true, subtree: true, characterData: true })
    observer.observe(content)
    observer.observe(layer)
    update()

    return () => {
      observer.disconnect()
      mutations.disconnect()
      cancelAnimationFrame(frame)
      player.style.removeProperty('--demo-calculator-scale')
    }
  }, [ contentRef, modalContainerRef, modalLayerRef ])
}
